import axios from 'axios';
import config from '../config';
import handleServiceResponse from '../hof/handleServiceResponse';

export class Drafts {
    static getAll = async (blogId) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/drafts`,
                method: 'GET'
            };
            const { data } = await axios(options);
            console.log(data.data);
            return data.data;
        })
    }
    
    static getAllPaginated = async (blogId, page, limit, sortBy, order) => {

        return await handleServiceResponse(async () => {
            let url = `${config.API_ADDR}/blogs/${blogId}/drafts?page=${page ? page - 1 : 0}&limit=${limit}`;

            if (sortBy) {
                url = `${url}&sortBy=${sortBy}`;
            }

            if (order) {
                url = `${url}&order=${order}`;
            }

            const options = {
                url,
                method: 'GET'
            };
            const { data } = await axios(options);
            return data;
        });
    }

    static removeDraft = async (blogId, draftId) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/drafts/${draftId}`,
                method: 'DELETE'
            };
            return await axios(options);
        });

    }

    static createDraft = async (blogId, draft) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/drafts`,
                method: 'POST',
                data: {
                    ...draft,
                    blogId
                }
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static updateDraft = async (blogId, draftId, draft) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/drafts/${draftId}`,
                method: 'PUT',
                data: draft
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static getSingle = async (blogId, draftId) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/drafts/${draftId}`,
                method: 'GET'
            };

            const { data } = await axios(options)
            return data;
        });

    }

}